<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        Opportunity
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <p v-if="stage.next_opportunity_id">An opportunity already exists for the next stage of this project. <router-link tag="a" :to="{ name: 'opportunities.overview', params: { 'opportunity_id': stage.next_opportunity_id }}">View</router-link></p>

                    <hr>
                    <p>Create an Opportunity for the next stage in this project.</p>

                    <p>Select a group or leave blank to use the base project from the costing.</p>

                    <div class="mb-3" v-if="costing && costing.user_story_document && costing.user_story_document.groups.length">
                        <label class="control-label">Select Group</label>
                        <div class="input-group">
                            <div class="flex-grow-1">
                                <multiselect :show-labels="false" v-model="group" :options="costing.user_story_document.groups" label="text" track-by="id" placeholder=""></multiselect>
                            </div>
                        </div>
                    </div>

                    <c-button class="btn btn-primary" @click="createOpportunity">Create Opportunity</c-button>

                    <hr>
                    <h3>Or</h3>
                    <p>Copy the userstories defined here to a stage 3.</p>


                    <c-button class="btn btn-primary" @click="convert">Convert</c-button><br/>
                    <c-button class="btn btn-primary mt-3" v-if="hasStage3" @click="updateBacklog">Update Stage 3</c-button><br/>
                    <small v-if="hasStage3">Add to the stage 3 sprint planning board any user stories that do not already exists. <br/>
                    Note it will not update existing ones.</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState } from 'vuex'
    import { http, notify } from 'utils'
    import Multiselect from 'vue-multiselect'
    import { LaddaButton } from 'components/form/input'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        extends: CModal,

        components: {
            LaddaButton,
            Multiselect
        },

        data() {
            return {
                costing: {},
                group: {}
            }
        },

        computed: {
            ...mapState('yodizproject', {
                project: 'single'
            }),
            ...mapState('yodizproject/stages', {
                stage: 'single'
            }),

            hasStage3 () {
              return this.project.stages.find((item) => item.stage_id === 3)
            }
        },

        mounted () {
            // CModal resets data when closed, so load the costing each time it opens
            this.addEventListener('open', () => {
                http.get('/user-story-document/'+this.project.user_story_document_id+'/costing').then(
                    (response) => {
                        this.costing = response.data
                })
            })
        },

        methods: {
            createOpportunity () {
                return http.post('/projects/'+this.$route.params.project_id+'/stages/'+this.$route.params.stage_id+'/opportunity', {group: this.group}).then((response) => {
                    notify.success('New Opportunity created. <a target="_blank" href="/opportunities/'+response.data.opportunity_id+'/overview">View</a>')
                }).catch((error) => {
                    notify.error(error.response.data.error)
                })
            },

            convert () {
                return http.post('/projects/'+this.$route.params.project_id+'/stages/'+this.$route.params.stage_id+'/convert', {}).then((response) => {
                    notify.success('Stage 3 Updated...')
                }).catch(() => {
                    notify.error("Looks like something went wrong")
                })
            },

            updateBacklog () {
                return http.post('/projects/'+this.$route.params.project_id+'/stages/'+this.$route.params.stage_id+'/update-backlog', {}).then((response) => {
                    notify.success('Stage 3 Updated. Created ' + response.data.created_count + ' new user stories')
                }).catch(() => {
                    notify.error("Looks like something went wrong")
                })
            }
        }
    }
</script>
